export const FormsScope = "FormsScope";
export const StatusScope = "StatusScope";
export const CrmStatusScope = "CrmStatusScope";
export const AuthScope = "AuthScope";
export const StudioScope = "StudioScope";
export const OrdersScope = "OrdersScope";
export const PartnerCenterScope = "PartnerCenterScope";
export const CurrentProgramScope = "CurrentProgramScope";
export const ProgramsScope = "ProgramsScope";
export const CapabilitiesScope = "CapabilitiesScope";
